import React, { useEffect, useState } from "react";
import ViewModal from "@core/modals/ViewModal";
import ViewButton from "@core/buttons/atoms/ViewButton";
import RowDetails from "@hoc/cruds/RowDetails";
import { useTranslation } from "react-i18next";
import PermissionHandler from "@hoc/cruds/PermissionHandler";
import WinchOperationService from "@services/WinchOperationService";

const ShowWinchOperation = ({ winchOperation }) => {
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);
  const [winchOperationData, setWinchOperationData] = useState([]);

  const closeModal = () => {
    setShowModal(false);
  };
  useEffect(() => {
    if (showModal)
      WinchOperationService.find(winchOperation.id).then((response) => {
        setWinchOperationData(response.data.data);
      });
  }, [winchOperation.id, showModal]);

  return (
    //TODO: Add the correct permission
    <PermissionHandler permission={"view_winch_operation_types"}>
      <ViewButton onClick={() => setShowModal(true)} />
      <ViewModal
        show={showModal}
        title={`${t("overview")}`}
        onClose={closeModal}
      >
        <div className="flex flex-col mt-5">
          <RowDetails label={t("name")} value={winchOperationData.name} />
          <RowDetails
            label={t("nameEng")}
            value={winchOperationData.name_eng}
          />
          <RowDetails
            label={t("description")}
            value={winchOperationData.description}
          />
        </div>
      </ViewModal>
    </PermissionHandler>
  );
};

export default ShowWinchOperation;
